import { DatePicker } from 'antd';
import React, { ReactElement } from 'react';
import {
  COMMON_DATE_FORMAT,
  COMMON_TIME_FORMAT,
  MONTH_YEAR_DATE_FORMAT,
} from '../../../constants/commonConstants';
import { useGetFormConfig } from '../../../hooks/useFormConfig';
import FormItem from '../FormItem/FormItem';
import { ReactComponent as Calendar } from '../../../../assets/images/svg/calendar.svg';

const FormInputDate = (props: any): (ReactElement | null) => {
  const formConfig = useGetFormConfig(props);
  const {
    disabled, placeholder, onChange, showTime, disabledDate, className, onFocus, onBlur,
    key, allowClear, extraFooter, picker, showNow, defaultValue, customIcon,
  } = formConfig;

  return <FormItem formConfig={formConfig}>
    <DatePicker
      allowClear={allowClear}
      data-testid={key}
      className={`form-date-picker ${className || ''}`}
      placeholder={placeholder}
      showTime={showTime}
      disabled={disabled}
      showNow={showNow}
      format={
        picker === 'month'
        ? (MONTH_YEAR_DATE_FORMAT)
        : (
          showTime
            ? `${COMMON_DATE_FORMAT} ${COMMON_TIME_FORMAT}`
            : COMMON_DATE_FORMAT
        )
      }
      onChange={(date: any, dateString: string): void => onChange(date, dateString)}
      renderExtraFooter={extraFooter}
      disabledDate={disabledDate}
      picker={picker}
      defaultValue= {defaultValue}
      suffixIcon={customIcon ? <Calendar /> : undefined}
      onBlur={(): void => onBlur && onBlur()}
      onFocus={(): void => onFocus && onFocus()}
    />
  </FormItem>;
};

export default FormInputDate;
